export type BrukerRolleFlagg =
    | 'isDrift'
    | 'isForvalter'
    | 'isHandelForvalter'
    | 'isKontorForvalter'
    | 'isOkonomi'
    | 'isQAOkonomi'
    | 'isProsjekteier'
    | 'isProsjektleder'
    | 'isForvaltningsdirektor'
    | 'isUtviklingsdirektor'
    | 'isAdministrerendedirektor'
    | 'isProsjektdirektor'
    | 'isOkonomisjef'
    | 'isProsjektkontroller'
    | 'isTeknisksjef'
    | 'isLeverandorAnsvarlig'
    | 'isBrukerAdministrator';

export enum BrukerRoller {
    Teamleder = 'Teamleder',
    Drift = 'Drift',
    Forvalter = 'Forvalter',
    Okonomi = 'Okonomi',
    OkonomiQA = 'OkonomiQA',
    Prosjekteier = 'Prosjekteier',
    Prosjektleder = 'Prosjektleder',
    Prosjektkontroller = 'Prosjektkontroller',
    Prosjektdirektor = 'Prosjektdirektor',
    Forvaltningsdirektor = 'Forvaltningsdirektor',
    Utviklingsdirektor = 'Utviklingsdirektor',
    Administrerendedirektor = 'Administrerendedirektor',
    Okonomisjef = 'Okonomisjef',
    Teknisksjef = 'Teknisksjef',
    Eiendomssjef = 'Eiendomssjef',
    Regiondirektor = 'Regiondirektor',
}

export type BrukerRolle = {
    id: number | undefined;
    brukerId: BrukerBaseInfo['brukerId'];
    rolle: BrukerRoller;
    region?: string;
};

export type ByggProsjektKontroller = {
    id?: number;
    brukerId: BrukerBaseInfo['brukerId'];
    byggNummer: string;
};

export type BrukerByggProsjektKontroller = {
    brukerId: BrukerBaseInfo['brukerId'];
    byggProsjektkontroller: Array<ByggProsjektKontroller>;
};

export type BrukerBaseInfo = {
    brukerId: string;
    epost: string;
    fornavn: string;
    etternavn: string;
    fulltnavn: string;
    superOfficeId?: number;
    created: Date;
    lastUpdated: Date;
    isDeleted: number;
    roller: Array<BrukerRolle>;
};

export type BrukerForvalter = {
    isSuperUser?: boolean;
    byggTyper: any; // @TODO: Add type
    isDeleted: number;
    isDrift: boolean;
    isForvalter: boolean;
    isHandelForvalter: boolean;
    isKontorForvalter: boolean;
    isOkonomi: boolean;
    isQAOkonomi: boolean;
    isProsjekteier: boolean;
    isProsjektleder: boolean;
    isForvaltningsdirektor: boolean;
    isUtviklingsdirektor: boolean;
    isAdministrerendedirektor: boolean;
    isBrukerAdministrator: boolean;
    isProsjektdirektor: boolean;
    isOkonomisjef: boolean;
    isTekniskSjef: boolean;
    isProsjektkontroller: boolean;
    isLeverandorAnsvarlig: boolean;
    region?: string;
    qaRegion?: string;
    byggRegioner?: Array<string>;
};

export type BrukerRegion = {
    qaRegion?: string;
    byggTyper: Array<string>;
    region?: string;
    byggRegioner: Array<string>;
    portfolioRegion: string;
    byggProsjektkontroller: Array<ByggProsjektKontroller>;
};

export type BrukerRegular = {
    hasKundeportalInteresse?: boolean;
    internalUser?: boolean;
    isSuperUser?: boolean;
    kundenummerList?: Array<string>;
    registered?: Date;
    updated?: Date;
    velkomstMeldingSendt?: Date;
};

export type BrukerTokenAccess = {
    isAdmin: boolean;
    isEDAdmin: boolean;
};

export type Bruker = BrukerBaseInfo &
    BrukerForvalter &
    BrukerRegion &
    BrukerRegular &
    BrukerTokenAccess;

export type BrukerRegionRequest = {
    brukerId: string;
    region: string;
};
